<p-fieldset legend="Global List">
  <div class="card documentTemplateGlobalList">
    <div class="flex flex-column card-container">
      <div>
        <p-button
        appPreventDoubleClick
          label="Add Document Template"
          id="addDocumentTemplateButton"
          icon="fa fa-plus"
          iconPos="left"
          class="align-right mb-2"
          styleClass="bpt-button-compact"
          (debounceClick)="addOrEditDocumentTemplate('')"
        ></p-button>
      </div>

      <div *ngIf = "!showLoader">
        <app-panel-list class="panelListPlaceHolder"
          [panelList]="documentTemplatesModalInput"
          [noResultFound]="!isDocumentTemplatesLoaded"
        >
          <ng-template #templateRef let-data="dataVar">
            <div panel-content class="grid">
              <div
                class="col-fixed text-2xl m-auto text-left"
                style="width: 10%"
              >
                <em
                  class="blue-color cursor-pointer"
                  (click)="downloadFile(data?.fileId, data?.fileName)"
                >
                  <app-file-icon [fileType]="data?.fileType"></app-file-icon
                ></em>
              </div>
              <div class="col-fixed text-left" style="width: 60%">
                <div class="font-semibold">Name</div>
                <div class="mt-1">
                  {{ data?.name }}
                </div>
              </div>
              <div class="col-fixed text-left" style="width: 16%">
                <div class="font-semibold">Is Active</div>
                <div class="mt-1">
                  <em
                    class="pi pi-circle-fill"
                    [ngClass]="calculateIsActiveColor(data?.isActive)"
                  ></em>
                  {{ data?.isActive }}
                </div>
              </div>
              <div class="col-fixed text-left" style="width: 14%">
                <span>
                  <em
                    class="fa fa-pen blue-color cursor-pointer"
                    (click)="
                      addOrEditDocumentTemplate(data?.documentTemplateId)
                    "
                  ></em>
                  <em
                  class="ml-2 fa fa-share-alt blue-color cursor-pointer"
                  (click)="
                    openWhereAmIUsedModal(data?.documentTemplateId)
                  "
                  ></em>
                  <em
                    *ngIf="data?.isActive === isActiveValueYes"
                    class="ml-2 fa fa-trash blue-color cursor-pointer"
                    (click)="
                      openDeleteConfirmationModal(data?.documentTemplateId)
                    "
                  ></em>
                </span>
              </div>
            </div>
          </ng-template>
        </app-panel-list>
      </div>
    </div>
  </div>
  <app-document-template-slider
    *ngIf="isDocumentTemplateSliderOpen"
    [isDocumentTemplateSliderOpen]="isDocumentTemplateSliderOpen"
    (isDocumentTemplateSliderActive)="closeDocumentTemplateSlider($event)"
    [documentTemplateDetail]="documentTemplateToEdit"
  ></app-document-template-slider>
  <app-where-am-i-used-modal
    *ngIf="isWhereAmIUsedModalVisible"
    [isWhereAmIUsedModalShow]="isWhereAmIUsedModalVisible"
    [whereAmIUsedList]="whereAmIUsedList"
    (isCloseWhereAmIUsedModal)="closeWhereAmIUsedModal($event)"
  ></app-where-am-i-used-modal>
</p-fieldset>
